// extracted by mini-css-extract-plugin
export default {"root":"Bvn2GyJuRebRhluUzR9W","more":"kZkToCuGSxlhctmBft2R"};